// Ukrainian translations for the UI
const translations: Record<string, string> = {
    // Navigation
    'nav.registry': 'Реєстр',
    'nav.lessons_group': 'Уроки',
    'nav.payments_group': 'Платежі',
    'nav.clients': 'Клієнти',
    'nav.students': 'Учні',
    'nav.teachers': 'Вчителі',
    'nav.subjects': 'Предмети',
    'nav.price_matrix': 'Ціни',
    'nav.teacher_rates': 'Ставки',
    'nav.lessons': 'Журнал',
    'nav.schedule': 'Розклад',
    'nav.payments': 'Журнал',
    'nav.debt_report': 'Борги',
    'nav.teacher_lessons_report': 'Звіт по уроках',
    'nav.navigation': 'Навігація',

    // Generic actions
    'action.save': 'Зберегти',
    'action.cancel': 'Скасувати',
    'action.edit': 'Редагувати',
    'action.delete': 'Видалити',
    'action.create': 'Створити',
    'action.search': 'Пошук',
    'action.clear': 'Очистити',
    'action.upload': 'Завантажити',
    'action.remove': 'Видалити',
    'action.close': 'Закрити',
    'action.show': 'Показати',
    'action.choose_file': 'Обрати файл',
    'action.retry': 'Спробувати знову',

    // Generic labels
    'label.id': 'ID',
    'label.name': "Ім'я",
    'label.comment': 'Коментар',
    'label.actions': 'Дії',
    'label.loading': 'Завантаження...',
    'label.error': 'Помилка',
    'label.needs_auth': 'Потрібна автентифікація',
    'label.not_found': 'Не знайдено',
    'label.no_data': 'Немає даних',
    'label.deleted': 'Видалено',
    'label.hidden': 'Приховано',
    'label.status': 'Статус',
    'label.date': 'Дата',
    'label.amount': 'Сума',
    'label.price': 'Ціна',
    'label.duration': 'Тривалість',
    'label.subject': 'Предмет',
    'label.teacher': 'Викладач',
    'label.student': 'Учень',
    'label.client': 'Клієнт',
    'label.payment': 'Оплата',
    'label.lesson': 'Урок',
    'label.balance': 'Баланс',
    'label.phone': 'Телефон',
    'label.email': 'Email',
    'label.instagram': 'Instagram',
    'label.telegram': 'Telegram',
    'label.links': 'Контакти',
    'label.students': 'Учні',
    'label.balance_available': 'Доступно',
    'label.paid': 'Сплачено',
    'label.used': 'Витрачено',
    'label.pending': 'Очікує',
    'label.available': 'Доступно',
    'label.debt': 'Баланс',
    'label.came_from': 'Звідки',
    'label.date_of_birth': 'Дата народження',
    'label.payment_by': 'Спосіб оплати',
    'label.receipt': 'Квитанція',
    'label.attachment': 'Вкладення',
    'label.completed': 'Виконано',
    'label.not_completed': 'Очікує',
    'label.individual': 'Індивідуально',
    'label.online': 'Онлайн',
    'label.created_at': 'Створено',
    'label.updated_at': 'Оновлено',

    // Clients
    'clients.title': 'Клієнти',
    'clients.new': '+ Новий клієнт',
    'clients.edit': 'Редагувати клієнта',
    'clients.search': 'Пошук за будь-яким полем...',
    'clients.no_clients': 'Немає клієнтів',
    'clients.not_found': 'Клієнта не знайдено',
    'clients.sort_creation': 'Дата створення',
    'clients.sort_update': 'Дата оновлення',
    'clients.sort_balance': 'Доступний баланс',
    'clients.sort_asc': '↑ За зрост.',
    'clients.sort_desc': '↓ За спадан.',
    'clients.delete_confirm': 'Позначити цього клієнта як видаленого?',
    'clients.name_required': "Ім'я обов'язкове",

    // Client Detail
    'client_detail.edit': 'Редагувати клієнта',
    'client_detail.add_student': '+ Додати учня',
    'client_detail.add_payment': '+ Додати платіж',
    'client_detail.add_lesson': '+ Додати урок',
    'client_detail.no_students': 'Немає учнів',
    'client_detail.no_payments': 'Немає платежів',
    'client_detail.no_lessons': 'Немає уроків',

    // Students
    'student.add': 'Додати учня',
    'student.edit': 'Редагувати учня',
    'student.name_required': "Ім'я учня обов'язкове",
    'student.delete_confirm': 'Позначити цього учня як видаленого?',

    // Teachers
    'teachers.title': 'Вчителі',
    'teachers.new': '+ Новий викладач',
    'teachers.edit': 'Редагувати викладача',
    'teachers.search': 'Пошук за іменем або ID...',
    'teachers.name_required': "Ім'я викладача обов'язкове",
    'teachers.delete_confirm': 'Позначити цього викладача як видаленого?',

    // Students
    'students.title': 'Учні',
    'students.search': 'Пошук за іменем або клієнтом...',
    'students.add_lesson': '+ Урок',
    'students.add_payment': '+ Платіж',

    // Subjects
    'subjects.title': 'Предмети',
    'subjects.new': '+ Новий предмет',
    'subjects.edit': 'Редагувати предмет',
    'subjects.search': 'Пошук за іменем або ID...',
    'subjects.name_required': "Назва предмета обов'язкова",
    'subjects.delete_confirm': 'Позначити цей предмет як видалений?',

    // Lessons
    'lessons.title': 'Уроки',
    'lessons.edit': 'Редагувати урок',
    'lessons.search': 'Пошук уроків...',
    'lessons.delete_confirm': 'Позначити цей урок як видалений?',
    'lessons.add_lesson': '+ Додати урок',
    'lessons.new_lesson': 'Новий урок',
    'lessons.student_required': "Учень обов'язковий",
    'lessons.teacher_required': "Викладач обов'язковий",
    'lessons.duration_invalid': 'Тривалість має бути > 0',
    'lessons.price_invalid': 'Некоректна ціна',
    'lessons.edit_title': 'Редагувати урок',
    'lessons.student_readonly': 'ID учня (тільки читання)',
    'lessons.done': '✓ виконано',
    'lessons.pending': '⏳ очікує',
    'lessons.filter_toggle': 'Фільтри',
    'lessons.filter_clear': 'Очистити фільтри',
    'lessons.filter_active': 'Активні фільтри: {count}',
    'lessons.filter_date_from': 'Дата з',
    'lessons.filter_date_to': 'Дата до',
    'lessons.filter_client': 'Клієнт',
    'lessons.filter_teacher': 'Викладач',
    'lessons.filter_student': 'Учень',
    'lessons.filter_subject': 'Предмет',
    'lessons.filter_duration_min': 'Тривалість від (хв)',
    'lessons.filter_duration_max': 'Тривалість до (хв)',
    'lessons.filter_price_min': 'Ціна від (₴)',
    'lessons.filter_price_max': 'Ціна до (₴)',
    'lessons.filter_status': 'Статус',
    'lessons.filter_status_all': 'Усі',
    'lessons.filter_status_completed': 'Виконані',
    'lessons.filter_status_pending': 'Очікують',
    'lessons.filter_no_clients': 'Немає клієнтів',
    'lessons.filter_no_teachers': 'Немає викладачів',
    'lessons.filter_no_students': 'Немає учнів',
    'lessons.filter_client_placeholder': 'Оберіть клієнта...',
    'lessons.filter_teacher_placeholder': 'Оберіть викладача...',
    'lessons.filter_student_placeholder': 'Оберіть учня...',
    'lessons.filter_subject_placeholder': 'Оберіть предмет...',

    // Price Matrix
    'price_matrix.title': 'Матриця цін',
    'price_matrix.save': 'Зберегти',
    'price_matrix.saved': 'Ціни збережено!',
    'price_matrix.teacher': 'Вчитель',
    'price_matrix.subjects': 'Предмети',
    'price_matrix.price': 'Ціна',
    'price_matrix.duration': 'Хвилин',
    'price_matrix.no_data': 'Немає даних. Додайте вчителів та предмети.',

    // Teacher Rates
    'teacher_rates.title': 'Ставки вчителів',
    'teacher_rates.rate': 'Ставка',
    'teacher_rates.start_date': 'Дата початку',

    // Schedule
    'schedule.title': 'Розклад уроків',
    'schedule.today': 'Сьогодні',
    'schedule.month': 'Місяць',
    'schedule.week': 'Тиждень',
    'schedule.day': 'День',
    'schedule.list': 'Список',

    // Payments
    'payments.title': 'Платежі',
    'payments.new': '+ Новий платіж',
    'payments.search': 'Пошук платежів...',
    'payments.client_required': "Клієнт обов'язковий",
    'payments.amount_invalid': 'Некоректна сума',
    'payments.datetime_required': "Дата та час обов'язкові",
    'payments.delete_confirm': 'Позначити цей платіж як видалений?',
    'payments.filter_toggle': 'Фільтри',
    'payments.filter_clear': 'Очистити фільтри',
    'payments.filter_active': 'Активні фільтри: {count}',
    'payments.filter_date_from': 'Дата з',
    'payments.filter_date_to': 'Дата до',
    'payments.filter_client': 'Клієнт',
    'payments.filter_amount_min': 'Сума від (₴)',
    'payments.filter_amount_max': 'Сума до (₴)',
    'payments.filter_comment': 'Коментар містить',
    'payments.filter_client_placeholder': 'Оберіть клієнта...',
    'payments.filter_no_clients': 'Немає клієнтів',
    'payments.upload_receipt': 'Завантажити квитанцію',
    'payments.show_attachment': 'Показати вкладення',
    'payments.remove_attachment': 'Видалити вкладення',
    'payments.remove_confirm': 'Видалити вкладення?',
    'payments.upload_failed': 'Не вдалося завантажити файл. Спробуйте ще раз.',

    // Payment Detail
    'payment_detail.title': 'Платіж',
    'payment_detail.edit': 'Редагувати платіж',

    // Reports
    'reports.most_indebted': 'Найбільші боржники',
    'reports.debt_description': 'Клієнти з найбільшою заборгованістю. Борг = платежі - використано - очікується. Від\u2019ємний борг означає, що клієнт винен гроші.',
    'reports.no_debt': 'Немає клієнтів із заборгованістю.',
    'reports.teacher_lessons': 'Звіт по уроках викладачів',
    'reports.group_by_day': 'По днях',
    'reports.group_by_week': 'По тижнях',
    'reports.group_by_month': 'По місяцях',
    'reports.teacher_summary': '{count} уроків, {earned} грн',
    'reports.teacher_summary_full': '{count} уроків, комп: {company_income} грн, вч: {teacher_income} грн',
    'reports.lesson_count': 'Кількість уроків',
    'reports.total_earned': 'Зароблено',
    'reports.company_income': 'Дохід компанії',
    'reports.teacher_income': 'Дохід вчителя',
    'reports.week': 'Тиждень',
    'reports.month': 'Місяць',
    'reports.no_teacher_lessons': 'Немає даних про уроки викладачів.',

    // Form placeholders
    'placeholder.full_name': "Повне ім'я",
    'placeholder.phone': '+380XXXXXXXXX',
    'placeholder.email': 'email@example.com',
    'placeholder.instagram': '@нікнейм',
    'placeholder.telegram': '@нікнейм',
    'placeholder.comment': '...',
    'placeholder.teacher_name': "Ім'я викладача",
    'placeholder.subject_name': 'Назва предмета',

    // Payment by options
    'payment_by.cash': 'Готівка',
    'payment_by.card': 'Картка',

    // Came from options
    'came_from.advertisement': 'Реклама',
    'came_from.instagram': 'Instagram',
    'came_from.client': 'Клієнт',
    'came_from.manager': 'Менеджер',
    'came_from.teacher': 'Викладач',
    'came_from.website': 'Вебсайт',
    'came_from.search': 'Пошук',
    'came_from.other': 'Інше',

    // Subject names (for calendar)
    'subject.none': '— немає —',

    // Telegram
    'telegram.connect': '🤖 Telegram',
    'telegram.link_copied': 'Посилання для підключення Telegram скопійовано!',
    'telegram.copied_title': 'Скопійовано',

    // Misc UI
    'ui.toggle_color': 'Перемкнути тему',
    'ui.logout': 'Вийти',
    'ui.login': 'Увійти',
    'ui.menu': 'Меню',

    // Errors
    'error.title': 'Щось пішло не так',
    'error.unknown': 'Невідома помилка',
    'error.fetch': 'Помилка отримання даних',
    'error.invalid_input': 'Некоректні дані',

    // Profile
    'profile.your_profile': 'Ваш профіль',
    'profile.name': "Ім'я",
    'profile.email': 'Email',
    'profile.your_permissions': 'Ваші дозволи',
};

export function t(key: string, params?: Record<string, string | number>): string {
    let text = translations[key] || key;
    if (params) {
        for (const [k, v] of Object.entries(params)) {
            text = text.replace(`{${k}}`, String(v));
        }
    }
    return text;
}

export default t;
